module.exports = __webpack_public_path__ + "img/av076.64804352.png";